<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'UserDetailTileField',
  components: { BaseField },
  data() {
    return {
      inputValue: '',
      selectValue: null,
      baseFieldValue: null,
    };
  },
  props: {
    field: Object,
    isEditMode: Boolean,
    showTitle: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    this.getBaseFieldValue();
  },
  computed: {
    fieldValue() {
      if (this.field.displayValue === null || this.field.displayValue.length === 0) {
        return this.field.emptyValue;
      }

      return this.field.displayValue;
    },

    fieldObject() {
      const fieldObject = {};

      fieldObject.type = this.field.changeType;
      fieldObject.label = this.field.emptyValue;
      fieldObject.defaultValue = this.field.changeType === 'select' ? null : '';
      fieldObject.constraints = {};
      fieldObject.options = this.field.changeType === 'select' ? this.field.options : [];

      return fieldObject;
    },

    emptyValueStyle() {
      return this.field.value === null || this.field.value === '';
    },
  },
  methods: {
    onInput(value) {
      this.$emit('change', value);
    },

    getBaseFieldValue() {
      if (this.field.changeType === 'date') {
        this.baseFieldValue = this.field.datePickerValue;
      }

      if (this.field.changeType === 'select') {
        this.baseFieldValue = this.field.value;
      }

      if (this.field.changeType === 'input') {
        this.baseFieldValue = this.field.value;
      }

      if (this.field.content === 'finance') {
        this.baseFieldValue = this.fieldValue;
      }
    },
  },
};
</script>

<template lang="pug">
  .b-user-detail-tile-field(v-if="(field.editView && isEditMode) || (field.displayView && !isEditMode)" :class="{ 'tile-field-edit': isEditMode }")
    ._horizontal(v-if="(field.displayView === 'horizontal' && !isEditMode) || (field.editView === 'horizontal' && isEditMode)" :class="{ 'field-border-bottom': field.borderBottom }")
      ._title(v-if="showTitle") {{ field.title }}
      ._value(v-if="!isEditMode" :class="{ 'empty-value': emptyValueStyle }") {{ fieldValue }}
      BaseField(v-if="isEditMode" v-model="baseFieldValue" v-bind="fieldObject" @change="onInput" @input="onInput")
    ._vertical(v-if="(field.displayView === 'vertical' && !isEditMode) || (field.editView === 'vertical' && isEditMode)" :class="{ 'field-border-bottom': field.borderBottom }")
      ._title(v-if="showTitle") {{ field.title }}
      ._value-area(v-if="!isEditMode")
        ._value(:class="{ 'empty-value': (!field.value && field.value === null) || field.value.length === 0 }") {{ fieldValue }}
      BaseField(v-if="isEditMode" v-model="baseFieldValue" v-bind="fieldObject" @change="onInput" @input="onInput")
</template>

<style scoped lang="scss">
.user-detail-tile-field {
  &__horizontal {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__vertical {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;

    &--edit-mode {
      padding: 0;
      margin: 15px 0;
    }
  }

  &__title {
    font-family: Geometria, sans-serif;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.4px;
    line-height: 1.5;
    color: rgba(146, 160, 176, 1);
  }

  &__value-area {
    background-color: rgba(245, 247, 249, 1);
    padding: 9px 12px;
    border-radius: 10px;
  }

  &__value {
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(30, 49, 71, 1);
  }
}

.field-border-bottom {
  padding-bottom: 15px;
  border-bottom: rgba(235, 239, 242, 1) 1px solid;
}

.empty-value {
  font-weight: 500;
  color: rgba(146, 160, 176, 1);
}

.tile-field-edit {
  width: 100%;
}
</style>
